module.exports = __webpack_public_path__ + "static/media/Headshot.b10e274c.jpeg";